export interface CountryCodeOption {
    value: string;
    country: string;
    countryEn: string;
    iso: string;
    label: string;
    searchText: string;
}

export const DEFAULT_COUNTRY_CODE = '+55';

export const COUNTRY_CODE_OPTIONS: CountryCodeOption[] = [
    {
        "value": "+93",
        "country": "Afeganistão",
        "countryEn": "Afghanistan",
        "iso": "AF",
        "label": "+93 · Afeganistão",
        "searchText": "+93 afeganistão afghanistan af 93"
    },
    {
        "value": "+27",
        "country": "África do Sul",
        "countryEn": "South Africa",
        "iso": "ZA",
        "label": "+27 · África do Sul",
        "searchText": "+27 áfrica do sul south africa za 27"
    },
    {
        "value": "+355",
        "country": "Albânia",
        "countryEn": "Albania",
        "iso": "AL",
        "label": "+355 · Albânia",
        "searchText": "+355 albânia albania al 355"
    },
    {
        "value": "+49",
        "country": "Alemanha",
        "countryEn": "Germany",
        "iso": "DE",
        "label": "+49 · Alemanha",
        "searchText": "+49 alemanha germany de 49"
    },
    {
        "value": "+376",
        "country": "Andorra",
        "countryEn": "Andorra",
        "iso": "AD",
        "label": "+376 · Andorra",
        "searchText": "+376 andorra andorra ad 376"
    },
    {
        "value": "+244",
        "country": "Angola",
        "countryEn": "Angola",
        "iso": "AO",
        "label": "+244 · Angola",
        "searchText": "+244 angola angola ao 244"
    },
    {
        "value": "+1",
        "country": "Anguilla",
        "countryEn": "Anguilla",
        "iso": "AI",
        "label": "+1 · Anguilla",
        "searchText": "+1 anguilla anguilla ai 1"
    },
    {
        "value": "+672",
        "country": "Antártida",
        "countryEn": "Antarctica",
        "iso": "AQ",
        "label": "+672 · Antártida",
        "searchText": "+672 antártida antarctica aq 672"
    },
    {
        "value": "+1",
        "country": "Antígua e Barbuda",
        "countryEn": "Antigua and Barbuda",
        "iso": "AG",
        "label": "+1 · Antígua e Barbuda",
        "searchText": "+1 antígua e barbuda antigua and barbuda ag 1"
    },
    {
        "value": "+966",
        "country": "Arábia Saudita",
        "countryEn": "Saudi Arabia",
        "iso": "SA",
        "label": "+966 · Arábia Saudita",
        "searchText": "+966 arábia saudita saudi arabia sa 966"
    },
    {
        "value": "+213",
        "country": "Argélia",
        "countryEn": "Algeria",
        "iso": "DZ",
        "label": "+213 · Argélia",
        "searchText": "+213 argélia algeria dz 213"
    },
    {
        "value": "+54",
        "country": "Argentina",
        "countryEn": "Argentina",
        "iso": "AR",
        "label": "+54 · Argentina",
        "searchText": "+54 argentina argentina ar 54"
    },
    {
        "value": "+374",
        "country": "Armênia",
        "countryEn": "Armenia",
        "iso": "AM",
        "label": "+374 · Armênia",
        "searchText": "+374 armênia armenia am 374"
    },
    {
        "value": "+297",
        "country": "Aruba",
        "countryEn": "Aruba",
        "iso": "AW",
        "label": "+297 · Aruba",
        "searchText": "+297 aruba aruba aw 297"
    },
    {
        "value": "+61",
        "country": "Austrália",
        "countryEn": "Australia",
        "iso": "AU",
        "label": "+61 · Austrália",
        "searchText": "+61 austrália australia au 61"
    },
    {
        "value": "+43",
        "country": "Áustria",
        "countryEn": "Austria",
        "iso": "AT",
        "label": "+43 · Áustria",
        "searchText": "+43 áustria austria at 43"
    },
    {
        "value": "+994",
        "country": "Azerbaijão",
        "countryEn": "Azerbaijan",
        "iso": "AZ",
        "label": "+994 · Azerbaijão",
        "searchText": "+994 azerbaijão azerbaijan az 994"
    },
    {
        "value": "+1",
        "country": "Bahamas",
        "countryEn": "Bahamas",
        "iso": "BS",
        "label": "+1 · Bahamas",
        "searchText": "+1 bahamas bahamas bs 1"
    },
    {
        "value": "+973",
        "country": "Bahrein",
        "countryEn": "Bahrain",
        "iso": "BH",
        "label": "+973 · Bahrein",
        "searchText": "+973 bahrein bahrain bh 973"
    },
    {
        "value": "+880",
        "country": "Bangladesh",
        "countryEn": "Bangladesh",
        "iso": "BD",
        "label": "+880 · Bangladesh",
        "searchText": "+880 bangladesh bangladesh bd 880"
    },
    {
        "value": "+1",
        "country": "Barbados",
        "countryEn": "Barbados",
        "iso": "BB",
        "label": "+1 · Barbados",
        "searchText": "+1 barbados barbados bb 1"
    },
    {
        "value": "+32",
        "country": "Bélgica",
        "countryEn": "Belgium",
        "iso": "BE",
        "label": "+32 · Bélgica",
        "searchText": "+32 bélgica belgium be 32"
    },
    {
        "value": "+501",
        "country": "Belize",
        "countryEn": "Belize",
        "iso": "BZ",
        "label": "+501 · Belize",
        "searchText": "+501 belize belize bz 501"
    },
    {
        "value": "+229",
        "country": "Benin",
        "countryEn": "Benin",
        "iso": "BJ",
        "label": "+229 · Benin",
        "searchText": "+229 benin benin bj 229"
    },
    {
        "value": "+1",
        "country": "Bermudas",
        "countryEn": "Bermuda",
        "iso": "BM",
        "label": "+1 · Bermudas",
        "searchText": "+1 bermudas bermuda bm 1"
    },
    {
        "value": "+375",
        "country": "Bielorrússia",
        "countryEn": "Belarus",
        "iso": "BY",
        "label": "+375 · Bielorrússia",
        "searchText": "+375 bielorrússia belarus by 375"
    },
    {
        "value": "+591",
        "country": "Bolívia",
        "countryEn": "Bolivia",
        "iso": "BO",
        "label": "+591 · Bolívia",
        "searchText": "+591 bolívia bolivia bo 591"
    },
    {
        "value": "+387",
        "country": "Bosnia e Herzegovina",
        "countryEn": "Bosnia and Herzegovina",
        "iso": "BA",
        "label": "+387 · Bosnia e Herzegovina",
        "searchText": "+387 bosnia e herzegovina bosnia and herzegovina ba 387"
    },
    {
        "value": "+267",
        "country": "Botsuana",
        "countryEn": "Botswana",
        "iso": "BW",
        "label": "+267 · Botsuana",
        "searchText": "+267 botsuana botswana bw 267"
    },
    {
        "value": "+55",
        "country": "Brasil",
        "countryEn": "Brazil",
        "iso": "BR",
        "label": "+55 · Brasil",
        "searchText": "+55 brasil brazil br 55"
    },
    {
        "value": "+673",
        "country": "Brunei",
        "countryEn": "Brunei",
        "iso": "BN",
        "label": "+673 · Brunei",
        "searchText": "+673 brunei brunei bn 673"
    },
    {
        "value": "+359",
        "country": "Bulgária",
        "countryEn": "Bulgaria",
        "iso": "BG",
        "label": "+359 · Bulgária",
        "searchText": "+359 bulgária bulgaria bg 359"
    },
    {
        "value": "+226",
        "country": "Burkina Faso",
        "countryEn": "Burkina Faso",
        "iso": "BF",
        "label": "+226 · Burkina Faso",
        "searchText": "+226 burkina faso burkina faso bf 226"
    },
    {
        "value": "+257",
        "country": "Burundi",
        "countryEn": "Burundi",
        "iso": "BI",
        "label": "+257 · Burundi",
        "searchText": "+257 burundi burundi bi 257"
    },
    {
        "value": "+975",
        "country": "Butão",
        "countryEn": "Bhutan",
        "iso": "BT",
        "label": "+975 · Butão",
        "searchText": "+975 butão bhutan bt 975"
    },
    {
        "value": "+238",
        "country": "Cabo Verde",
        "countryEn": "Cabo Verde",
        "iso": "CV",
        "label": "+238 · Cabo Verde",
        "searchText": "+238 cabo verde cabo verde cv 238"
    },
    {
        "value": "+237",
        "country": "Camarões",
        "countryEn": "Cameroon",
        "iso": "CM",
        "label": "+237 · Camarões",
        "searchText": "+237 camarões cameroon cm 237"
    },
    {
        "value": "+855",
        "country": "Camboja",
        "countryEn": "Cambodia",
        "iso": "KH",
        "label": "+855 · Camboja",
        "searchText": "+855 camboja cambodia kh 855"
    },
    {
        "value": "+1",
        "country": "Canadá",
        "countryEn": "Canada",
        "iso": "CA",
        "label": "+1 · Canadá",
        "searchText": "+1 canadá canada ca 1"
    },
    {
        "value": "+599",
        "country": "Caribe Neerlandês",
        "countryEn": "Caribbean Netherlands",
        "iso": "BQ",
        "label": "+599 · Caribe Neerlandês",
        "searchText": "+599 caribe neerlandês caribbean netherlands bq 599"
    },
    {
        "value": "+974",
        "country": "Catar",
        "countryEn": "Qatar",
        "iso": "QA",
        "label": "+974 · Catar",
        "searchText": "+974 catar qatar qa 974"
    },
    {
        "value": "+7",
        "country": "Cazaquistão",
        "countryEn": "Kazakhstan",
        "iso": "KZ",
        "label": "+7 · Cazaquistão",
        "searchText": "+7 cazaquistão kazakhstan kz 7"
    },
    {
        "value": "+235",
        "country": "Chade",
        "countryEn": "Chad",
        "iso": "TD",
        "label": "+235 · Chade",
        "searchText": "+235 chade chad td 235"
    },
    {
        "value": "+56",
        "country": "Chile",
        "countryEn": "Chile",
        "iso": "CL",
        "label": "+56 · Chile",
        "searchText": "+56 chile chile cl 56"
    },
    {
        "value": "+86",
        "country": "China",
        "countryEn": "China",
        "iso": "CN",
        "label": "+86 · China",
        "searchText": "+86 china china cn 86"
    },
    {
        "value": "+357",
        "country": "Chipre",
        "countryEn": "Cyprus",
        "iso": "CY",
        "label": "+357 · Chipre",
        "searchText": "+357 chipre cyprus cy 357"
    },
    {
        "value": "+57",
        "country": "Colômbia",
        "countryEn": "Colombia",
        "iso": "CO",
        "label": "+57 · Colômbia",
        "searchText": "+57 colômbia colombia co 57"
    },
    {
        "value": "+269",
        "country": "Comores",
        "countryEn": "Comoros",
        "iso": "KM",
        "label": "+269 · Comores",
        "searchText": "+269 comores comoros km 269"
    },
    {
        "value": "+242",
        "country": "Congo",
        "countryEn": "Congo",
        "iso": "CG",
        "label": "+242 · Congo",
        "searchText": "+242 congo congo cg 242"
    },
    {
        "value": "+243",
        "country": "Congo (RDC)",
        "countryEn": "Congo (DRC)",
        "iso": "CD",
        "label": "+243 · Congo (RDC)",
        "searchText": "+243 congo (rdc) congo (drc) cd 243"
    },
    {
        "value": "+850",
        "country": "Coreia do Norte",
        "countryEn": "Korea (North)",
        "iso": "KP",
        "label": "+850 · Coreia do Norte",
        "searchText": "+850 coreia do norte korea (north) kp 850"
    },
    {
        "value": "+82",
        "country": "Coreia do Sul",
        "countryEn": "Korea (South)",
        "iso": "KR",
        "label": "+82 · Coreia do Sul",
        "searchText": "+82 coreia do sul korea (south) kr 82"
    },
    {
        "value": "+225",
        "country": "Costa do Marfim",
        "countryEn": "Côte d'Ivoire",
        "iso": "CI",
        "label": "+225 · Costa do Marfim",
        "searchText": "+225 costa do marfim côte d'ivoire ci 225"
    },
    {
        "value": "+506",
        "country": "Costa Rica",
        "countryEn": "Costa Rica",
        "iso": "CR",
        "label": "+506 · Costa Rica",
        "searchText": "+506 costa rica costa rica cr 506"
    },
    {
        "value": "+385",
        "country": "Croácia",
        "countryEn": "Croatia",
        "iso": "HR",
        "label": "+385 · Croácia",
        "searchText": "+385 croácia croatia hr 385"
    },
    {
        "value": "+53",
        "country": "Cuba",
        "countryEn": "Cuba",
        "iso": "CU",
        "label": "+53 · Cuba",
        "searchText": "+53 cuba cuba cu 53"
    },
    {
        "value": "+599",
        "country": "Curaçao",
        "countryEn": "Curaçao",
        "iso": "CW",
        "label": "+599 · Curaçao",
        "searchText": "+599 curaçao curaçao cw 599"
    },
    {
        "value": "+45",
        "country": "Dinamarca",
        "countryEn": "Denmark",
        "iso": "DK",
        "label": "+45 · Dinamarca",
        "searchText": "+45 dinamarca denmark dk 45"
    },
    {
        "value": "+253",
        "country": "Djibuti",
        "countryEn": "Djibouti",
        "iso": "DJ",
        "label": "+253 · Djibuti",
        "searchText": "+253 djibuti djibouti dj 253"
    },
    {
        "value": "+1",
        "country": "Dominica",
        "countryEn": "Dominica",
        "iso": "DM",
        "label": "+1 · Dominica",
        "searchText": "+1 dominica dominica dm 1"
    },
    {
        "value": "+20",
        "country": "Egito",
        "countryEn": "Egypt",
        "iso": "EG",
        "label": "+20 · Egito",
        "searchText": "+20 egito egypt eg 20"
    },
    {
        "value": "+503",
        "country": "El Salvador",
        "countryEn": "El Salvador",
        "iso": "SV",
        "label": "+503 · El Salvador",
        "searchText": "+503 el salvador el salvador sv 503"
    },
    {
        "value": "+971",
        "country": "Emirados Árabes Unidos",
        "countryEn": "United Arab Emirates",
        "iso": "AE",
        "label": "+971 · Emirados Árabes Unidos",
        "searchText": "+971 emirados árabes unidos united arab emirates ae 971"
    },
    {
        "value": "+593",
        "country": "Equador",
        "countryEn": "Ecuador",
        "iso": "EC",
        "label": "+593 · Equador",
        "searchText": "+593 equador ecuador ec 593"
    },
    {
        "value": "+291",
        "country": "Eritreia",
        "countryEn": "Eritrea",
        "iso": "ER",
        "label": "+291 · Eritreia",
        "searchText": "+291 eritreia eritrea er 291"
    },
    {
        "value": "+421",
        "country": "Eslováquia",
        "countryEn": "Slovakia",
        "iso": "SK",
        "label": "+421 · Eslováquia",
        "searchText": "+421 eslováquia slovakia sk 421"
    },
    {
        "value": "+386",
        "country": "Eslovênia",
        "countryEn": "Slovenia",
        "iso": "SI",
        "label": "+386 · Eslovênia",
        "searchText": "+386 eslovênia slovenia si 386"
    },
    {
        "value": "+34",
        "country": "Espanha",
        "countryEn": "Spain",
        "iso": "ES",
        "label": "+34 · Espanha",
        "searchText": "+34 espanha spain es 34"
    },
    {
        "value": "+1",
        "country": "Estados Unidos",
        "countryEn": "United States",
        "iso": "US",
        "label": "+1 · Estados Unidos",
        "searchText": "+1 estados unidos united states us 1"
    },
    {
        "value": "+372",
        "country": "Estônia",
        "countryEn": "Estonia",
        "iso": "EE",
        "label": "+372 · Estônia",
        "searchText": "+372 estônia estonia ee 372"
    },
    {
        "value": "+268",
        "country": "Eswatini",
        "countryEn": "Eswatini",
        "iso": "SZ",
        "label": "+268 · Eswatini",
        "searchText": "+268 eswatini eswatini sz 268"
    },
    {
        "value": "+251",
        "country": "Etiópia",
        "countryEn": "Ethiopia",
        "iso": "ET",
        "label": "+251 · Etiópia",
        "searchText": "+251 etiópia ethiopia et 251"
    },
    {
        "value": "+679",
        "country": "Fiji",
        "countryEn": "Fiji",
        "iso": "FJ",
        "label": "+679 · Fiji",
        "searchText": "+679 fiji fiji fj 679"
    },
    {
        "value": "+63",
        "country": "Filipinas",
        "countryEn": "Philippines",
        "iso": "PH",
        "label": "+63 · Filipinas",
        "searchText": "+63 filipinas philippines ph 63"
    },
    {
        "value": "+358",
        "country": "Finlândia",
        "countryEn": "Finland",
        "iso": "FI",
        "label": "+358 · Finlândia",
        "searchText": "+358 finlândia finland fi 358"
    },
    {
        "value": "+33",
        "country": "França",
        "countryEn": "France",
        "iso": "FR",
        "label": "+33 · França",
        "searchText": "+33 frança france fr 33"
    },
    {
        "value": "+241",
        "country": "Gabão",
        "countryEn": "Gabon",
        "iso": "GA",
        "label": "+241 · Gabão",
        "searchText": "+241 gabão gabon ga 241"
    },
    {
        "value": "+220",
        "country": "Gâmbia",
        "countryEn": "Gambia",
        "iso": "GM",
        "label": "+220 · Gâmbia",
        "searchText": "+220 gâmbia gambia gm 220"
    },
    {
        "value": "+233",
        "country": "Gana",
        "countryEn": "Ghana",
        "iso": "GH",
        "label": "+233 · Gana",
        "searchText": "+233 gana ghana gh 233"
    },
    {
        "value": "+995",
        "country": "Geórgia",
        "countryEn": "Georgia",
        "iso": "GE",
        "label": "+995 · Geórgia",
        "searchText": "+995 geórgia georgia ge 995"
    },
    {
        "value": "+350",
        "country": "Gibraltar",
        "countryEn": "Gibraltar",
        "iso": "GI",
        "label": "+350 · Gibraltar",
        "searchText": "+350 gibraltar gibraltar gi 350"
    },
    {
        "value": "+1",
        "country": "Granada",
        "countryEn": "Grenada",
        "iso": "GD",
        "label": "+1 · Granada",
        "searchText": "+1 granada grenada gd 1"
    },
    {
        "value": "+30",
        "country": "Grécia",
        "countryEn": "Greece",
        "iso": "GR",
        "label": "+30 · Grécia",
        "searchText": "+30 grécia greece gr 30"
    },
    {
        "value": "+299",
        "country": "Groenlândia",
        "countryEn": "Greenland",
        "iso": "GL",
        "label": "+299 · Groenlândia",
        "searchText": "+299 groenlândia greenland gl 299"
    },
    {
        "value": "+590",
        "country": "Guadalupe",
        "countryEn": "Guadeloupe",
        "iso": "GP",
        "label": "+590 · Guadalupe",
        "searchText": "+590 guadalupe guadeloupe gp 590"
    },
    {
        "value": "+1",
        "country": "Guam",
        "countryEn": "Guam",
        "iso": "GU",
        "label": "+1 · Guam",
        "searchText": "+1 guam guam gu 1"
    },
    {
        "value": "+502",
        "country": "Guatemala",
        "countryEn": "Guatemala",
        "iso": "GT",
        "label": "+502 · Guatemala",
        "searchText": "+502 guatemala guatemala gt 502"
    },
    {
        "value": "+44",
        "country": "Guernsey",
        "countryEn": "Guernsey",
        "iso": "GG",
        "label": "+44 · Guernsey",
        "searchText": "+44 guernsey guernsey gg 44"
    },
    {
        "value": "+592",
        "country": "Guiana",
        "countryEn": "Guyana",
        "iso": "GY",
        "label": "+592 · Guiana",
        "searchText": "+592 guiana guyana gy 592"
    },
    {
        "value": "+594",
        "country": "Guiana Francesa",
        "countryEn": "French Guiana",
        "iso": "GF",
        "label": "+594 · Guiana Francesa",
        "searchText": "+594 guiana francesa french guiana gf 594"
    },
    {
        "value": "+224",
        "country": "Guiné",
        "countryEn": "Guinea",
        "iso": "GN",
        "label": "+224 · Guiné",
        "searchText": "+224 guiné guinea gn 224"
    },
    {
        "value": "+240",
        "country": "Guiné Equatorial",
        "countryEn": "Equatorial Guinea",
        "iso": "GQ",
        "label": "+240 · Guiné Equatorial",
        "searchText": "+240 guiné equatorial equatorial guinea gq 240"
    },
    {
        "value": "+245",
        "country": "Guiné-Bissau",
        "countryEn": "Guinea-Bissau",
        "iso": "GW",
        "label": "+245 · Guiné-Bissau",
        "searchText": "+245 guiné-bissau guinea-bissau gw 245"
    },
    {
        "value": "+509",
        "country": "Haiti",
        "countryEn": "Haiti",
        "iso": "HT",
        "label": "+509 · Haiti",
        "searchText": "+509 haiti haiti ht 509"
    },
    {
        "value": "+504",
        "country": "Honduras",
        "countryEn": "Honduras",
        "iso": "HN",
        "label": "+504 · Honduras",
        "searchText": "+504 honduras honduras hn 504"
    },
    {
        "value": "+852",
        "country": "Hong Kong",
        "countryEn": "Hong Kong",
        "iso": "HK",
        "label": "+852 · Hong Kong",
        "searchText": "+852 hong kong hong kong hk 852"
    },
    {
        "value": "+36",
        "country": "Hungria",
        "countryEn": "Hungary",
        "iso": "HU",
        "label": "+36 · Hungria",
        "searchText": "+36 hungria hungary hu 36"
    },
    {
        "value": "+967",
        "country": "Iêmen",
        "countryEn": "Yemen",
        "iso": "YE",
        "label": "+967 · Iêmen",
        "searchText": "+967 iêmen yemen ye 967"
    },
    {
        "value": "+61",
        "country": "Ilha Christmas",
        "countryEn": "Christmas Island",
        "iso": "CX",
        "label": "+61 · Ilha Christmas",
        "searchText": "+61 ilha christmas christmas island cx 61"
    },
    {
        "value": "+44",
        "country": "Ilha de Man",
        "countryEn": "Isle of Man",
        "iso": "IM",
        "label": "+44 · Ilha de Man",
        "searchText": "+44 ilha de man isle of man im 44"
    },
    {
        "value": "+672",
        "country": "Ilha Norfolk",
        "countryEn": "Norfolk Island",
        "iso": "NF",
        "label": "+672 · Ilha Norfolk",
        "searchText": "+672 ilha norfolk norfolk island nf 672"
    },
    {
        "value": "+358",
        "country": "Ilhas Åland",
        "countryEn": "Åland Islands",
        "iso": "AX",
        "label": "+358 · Ilhas Åland",
        "searchText": "+358 ilhas åland åland islands ax 358"
    },
    {
        "value": "+1",
        "country": "Ilhas Cayman",
        "countryEn": "Cayman Islands",
        "iso": "KY",
        "label": "+1 · Ilhas Cayman",
        "searchText": "+1 ilhas cayman cayman islands ky 1"
    },
    {
        "value": "+61",
        "country": "Ilhas Cocos",
        "countryEn": "Cocos Islands",
        "iso": "CC",
        "label": "+61 · Ilhas Cocos",
        "searchText": "+61 ilhas cocos cocos islands cc 61"
    },
    {
        "value": "+500",
        "country": "Ilhas Falkland",
        "countryEn": "Falkland Islands",
        "iso": "FK",
        "label": "+500 · Ilhas Falkland",
        "searchText": "+500 ilhas falkland falkland islands fk 500"
    },
    {
        "value": "+298",
        "country": "Ilhas Faroé",
        "countryEn": "Faroe Islands",
        "iso": "FO",
        "label": "+298 · Ilhas Faroé",
        "searchText": "+298 ilhas faroé faroe islands fo 298"
    },
    {
        "value": "+1",
        "country": "Ilhas Marianas do Norte",
        "countryEn": "Northern Mariana Islands",
        "iso": "MP",
        "label": "+1 · Ilhas Marianas do Norte",
        "searchText": "+1 ilhas marianas do norte northern mariana islands mp 1"
    },
    {
        "value": "+692",
        "country": "Ilhas Marshall",
        "countryEn": "Marshall Islands",
        "iso": "MH",
        "label": "+692 · Ilhas Marshall",
        "searchText": "+692 ilhas marshall marshall islands mh 692"
    },
    {
        "value": "+64",
        "country": "Ilhas Pitcairn",
        "countryEn": "Pitcairn Islands",
        "iso": "PN",
        "label": "+64 · Ilhas Pitcairn",
        "searchText": "+64 ilhas pitcairn pitcairn islands pn 64"
    },
    {
        "value": "+677",
        "country": "Ilhas Salomão",
        "countryEn": "Solomon Islands",
        "iso": "SB",
        "label": "+677 · Ilhas Salomão",
        "searchText": "+677 ilhas salomão solomon islands sb 677"
    },
    {
        "value": "+1",
        "country": "Ilhas Turks e Caicos",
        "countryEn": "Turks and Caicos Islands",
        "iso": "TC",
        "label": "+1 · Ilhas Turks e Caicos",
        "searchText": "+1 ilhas turks e caicos turks and caicos islands tc 1"
    },
    {
        "value": "+1",
        "country": "Ilhas Virgens Americanas",
        "countryEn": "Virgin Islands (U.S.)",
        "iso": "VI",
        "label": "+1 · Ilhas Virgens Americanas",
        "searchText": "+1 ilhas virgens americanas virgin islands (u.s.) vi 1"
    },
    {
        "value": "+1",
        "country": "Ilhas Virgens Britânicas",
        "countryEn": "Virgin Islands (British)",
        "iso": "VG",
        "label": "+1 · Ilhas Virgens Britânicas",
        "searchText": "+1 ilhas virgens britânicas virgin islands (british) vg 1"
    },
    {
        "value": "+91",
        "country": "Índia",
        "countryEn": "India",
        "iso": "IN",
        "label": "+91 · Índia",
        "searchText": "+91 índia india in 91"
    },
    {
        "value": "+62",
        "country": "Indonésia",
        "countryEn": "Indonesia",
        "iso": "ID",
        "label": "+62 · Indonésia",
        "searchText": "+62 indonésia indonesia id 62"
    },
    {
        "value": "+98",
        "country": "Irã",
        "countryEn": "Iran",
        "iso": "IR",
        "label": "+98 · Irã",
        "searchText": "+98 irã iran ir 98"
    },
    {
        "value": "+964",
        "country": "Iraque",
        "countryEn": "Iraq",
        "iso": "IQ",
        "label": "+964 · Iraque",
        "searchText": "+964 iraque iraq iq 964"
    },
    {
        "value": "+353",
        "country": "Irlanda",
        "countryEn": "Ireland",
        "iso": "IE",
        "label": "+353 · Irlanda",
        "searchText": "+353 irlanda ireland ie 353"
    },
    {
        "value": "+354",
        "country": "Islândia",
        "countryEn": "Iceland",
        "iso": "IS",
        "label": "+354 · Islândia",
        "searchText": "+354 islândia iceland is 354"
    },
    {
        "value": "+972",
        "country": "Israel",
        "countryEn": "Israel",
        "iso": "IL",
        "label": "+972 · Israel",
        "searchText": "+972 israel israel il 972"
    },
    {
        "value": "+39",
        "country": "Itália",
        "countryEn": "Italy",
        "iso": "IT",
        "label": "+39 · Itália",
        "searchText": "+39 itália italy it 39"
    },
    {
        "value": "+1",
        "country": "Jamaica",
        "countryEn": "Jamaica",
        "iso": "JM",
        "label": "+1 · Jamaica",
        "searchText": "+1 jamaica jamaica jm 1"
    },
    {
        "value": "+81",
        "country": "Japão",
        "countryEn": "Japan",
        "iso": "JP",
        "label": "+81 · Japão",
        "searchText": "+81 japão japan jp 81"
    },
    {
        "value": "+44",
        "country": "Jersey",
        "countryEn": "Jersey",
        "iso": "JE",
        "label": "+44 · Jersey",
        "searchText": "+44 jersey jersey je 44"
    },
    {
        "value": "+962",
        "country": "Jordânia",
        "countryEn": "Jordan",
        "iso": "JO",
        "label": "+962 · Jordânia",
        "searchText": "+962 jordânia jordan jo 962"
    },
    {
        "value": "+686",
        "country": "Kiribati",
        "countryEn": "Kiribati",
        "iso": "KI",
        "label": "+686 · Kiribati",
        "searchText": "+686 kiribati kiribati ki 686"
    },
    {
        "value": "+383",
        "country": "Kosovo",
        "countryEn": "Kosovo",
        "iso": "XK",
        "label": "+383 · Kosovo",
        "searchText": "+383 kosovo kosovo xk 383"
    },
    {
        "value": "+965",
        "country": "Kuwait",
        "countryEn": "Kuwait",
        "iso": "KW",
        "label": "+965 · Kuwait",
        "searchText": "+965 kuwait kuwait kw 965"
    },
    {
        "value": "+856",
        "country": "Laos",
        "countryEn": "Laos",
        "iso": "LA",
        "label": "+856 · Laos",
        "searchText": "+856 laos laos la 856"
    },
    {
        "value": "+266",
        "country": "Lesoto",
        "countryEn": "Lesotho",
        "iso": "LS",
        "label": "+266 · Lesoto",
        "searchText": "+266 lesoto lesotho ls 266"
    },
    {
        "value": "+371",
        "country": "Letônia",
        "countryEn": "Latvia",
        "iso": "LV",
        "label": "+371 · Letônia",
        "searchText": "+371 letônia latvia lv 371"
    },
    {
        "value": "+961",
        "country": "Líbano",
        "countryEn": "Lebanon",
        "iso": "LB",
        "label": "+961 · Líbano",
        "searchText": "+961 líbano lebanon lb 961"
    },
    {
        "value": "+231",
        "country": "Libéria",
        "countryEn": "Liberia",
        "iso": "LR",
        "label": "+231 · Libéria",
        "searchText": "+231 libéria liberia lr 231"
    },
    {
        "value": "+218",
        "country": "Líbia",
        "countryEn": "Libya",
        "iso": "LY",
        "label": "+218 · Líbia",
        "searchText": "+218 líbia libya ly 218"
    },
    {
        "value": "+423",
        "country": "Liechtenstein",
        "countryEn": "Liechtenstein",
        "iso": "LI",
        "label": "+423 · Liechtenstein",
        "searchText": "+423 liechtenstein liechtenstein li 423"
    },
    {
        "value": "+370",
        "country": "Lituânia",
        "countryEn": "Lithuania",
        "iso": "LT",
        "label": "+370 · Lituânia",
        "searchText": "+370 lituânia lithuania lt 370"
    },
    {
        "value": "+352",
        "country": "Luxemburgo",
        "countryEn": "Luxembourg",
        "iso": "LU",
        "label": "+352 · Luxemburgo",
        "searchText": "+352 luxemburgo luxembourg lu 352"
    },
    {
        "value": "+853",
        "country": "Macau",
        "countryEn": "Macao",
        "iso": "MO",
        "label": "+853 · Macau",
        "searchText": "+853 macau macao mo 853"
    },
    {
        "value": "+389",
        "country": "Macedônia do Norte",
        "countryEn": "North Macedonia",
        "iso": "MK",
        "label": "+389 · Macedônia do Norte",
        "searchText": "+389 macedônia do norte north macedonia mk 389"
    },
    {
        "value": "+261",
        "country": "Madagascar",
        "countryEn": "Madagascar",
        "iso": "MG",
        "label": "+261 · Madagascar",
        "searchText": "+261 madagascar madagascar mg 261"
    },
    {
        "value": "+60",
        "country": "Malásia",
        "countryEn": "Malaysia",
        "iso": "MY",
        "label": "+60 · Malásia",
        "searchText": "+60 malásia malaysia my 60"
    },
    {
        "value": "+265",
        "country": "Malawi",
        "countryEn": "Malawi",
        "iso": "MW",
        "label": "+265 · Malawi",
        "searchText": "+265 malawi malawi mw 265"
    },
    {
        "value": "+960",
        "country": "Maldivas",
        "countryEn": "Maldives",
        "iso": "MV",
        "label": "+960 · Maldivas",
        "searchText": "+960 maldivas maldives mv 960"
    },
    {
        "value": "+223",
        "country": "Mali",
        "countryEn": "Mali",
        "iso": "ML",
        "label": "+223 · Mali",
        "searchText": "+223 mali mali ml 223"
    },
    {
        "value": "+356",
        "country": "Malta",
        "countryEn": "Malta",
        "iso": "MT",
        "label": "+356 · Malta",
        "searchText": "+356 malta malta mt 356"
    },
    {
        "value": "+212",
        "country": "Marrocos",
        "countryEn": "Morocco",
        "iso": "MA",
        "label": "+212 · Marrocos",
        "searchText": "+212 marrocos morocco ma 212"
    },
    {
        "value": "+596",
        "country": "Martinica",
        "countryEn": "Martinique",
        "iso": "MQ",
        "label": "+596 · Martinica",
        "searchText": "+596 martinica martinique mq 596"
    },
    {
        "value": "+230",
        "country": "Maurício",
        "countryEn": "Mauritius",
        "iso": "MU",
        "label": "+230 · Maurício",
        "searchText": "+230 maurício mauritius mu 230"
    },
    {
        "value": "+222",
        "country": "Mauritânia",
        "countryEn": "Mauritania",
        "iso": "MR",
        "label": "+222 · Mauritânia",
        "searchText": "+222 mauritânia mauritania mr 222"
    },
    {
        "value": "+262",
        "country": "Mayotte",
        "countryEn": "Mayotte",
        "iso": "YT",
        "label": "+262 · Mayotte",
        "searchText": "+262 mayotte mayotte yt 262"
    },
    {
        "value": "+52",
        "country": "México",
        "countryEn": "Mexico",
        "iso": "MX",
        "label": "+52 · México",
        "searchText": "+52 méxico mexico mx 52"
    },
    {
        "value": "+691",
        "country": "Micronésia",
        "countryEn": "Micronesia",
        "iso": "FM",
        "label": "+691 · Micronésia",
        "searchText": "+691 micronésia micronesia fm 691"
    },
    {
        "value": "+258",
        "country": "Moçambique",
        "countryEn": "Mozambique",
        "iso": "MZ",
        "label": "+258 · Moçambique",
        "searchText": "+258 moçambique mozambique mz 258"
    },
    {
        "value": "+373",
        "country": "Moldávia",
        "countryEn": "Moldova",
        "iso": "MD",
        "label": "+373 · Moldávia",
        "searchText": "+373 moldávia moldova md 373"
    },
    {
        "value": "+377",
        "country": "Mônaco",
        "countryEn": "Monaco",
        "iso": "MC",
        "label": "+377 · Mônaco",
        "searchText": "+377 mônaco monaco mc 377"
    },
    {
        "value": "+976",
        "country": "Mongólia",
        "countryEn": "Mongolia",
        "iso": "MN",
        "label": "+976 · Mongólia",
        "searchText": "+976 mongólia mongolia mn 976"
    },
    {
        "value": "+382",
        "country": "Montenegro",
        "countryEn": "Montenegro",
        "iso": "ME",
        "label": "+382 · Montenegro",
        "searchText": "+382 montenegro montenegro me 382"
    },
    {
        "value": "+1",
        "country": "Montserrat",
        "countryEn": "Montserrat",
        "iso": "MS",
        "label": "+1 · Montserrat",
        "searchText": "+1 montserrat montserrat ms 1"
    },
    {
        "value": "+95",
        "country": "Myanmar",
        "countryEn": "Myanmar",
        "iso": "MM",
        "label": "+95 · Myanmar",
        "searchText": "+95 myanmar myanmar mm 95"
    },
    {
        "value": "+264",
        "country": "Namíbia",
        "countryEn": "Namibia",
        "iso": "NA",
        "label": "+264 · Namíbia",
        "searchText": "+264 namíbia namibia na 264"
    },
    {
        "value": "+674",
        "country": "Nauru",
        "countryEn": "Nauru",
        "iso": "NR",
        "label": "+674 · Nauru",
        "searchText": "+674 nauru nauru nr 674"
    },
    {
        "value": "+977",
        "country": "Nepal",
        "countryEn": "Nepal",
        "iso": "NP",
        "label": "+977 · Nepal",
        "searchText": "+977 nepal nepal np 977"
    },
    {
        "value": "+505",
        "country": "Nicarágua",
        "countryEn": "Nicaragua",
        "iso": "NI",
        "label": "+505 · Nicarágua",
        "searchText": "+505 nicarágua nicaragua ni 505"
    },
    {
        "value": "+227",
        "country": "Níger",
        "countryEn": "Niger",
        "iso": "NE",
        "label": "+227 · Níger",
        "searchText": "+227 níger niger ne 227"
    },
    {
        "value": "+234",
        "country": "Nigéria",
        "countryEn": "Nigeria",
        "iso": "NG",
        "label": "+234 · Nigéria",
        "searchText": "+234 nigéria nigeria ng 234"
    },
    {
        "value": "+683",
        "country": "Niue",
        "countryEn": "Niue",
        "iso": "NU",
        "label": "+683 · Niue",
        "searchText": "+683 niue niue nu 683"
    },
    {
        "value": "+47",
        "country": "Noruega",
        "countryEn": "Norway",
        "iso": "NO",
        "label": "+47 · Noruega",
        "searchText": "+47 noruega norway no 47"
    },
    {
        "value": "+687",
        "country": "Nova Caledônia",
        "countryEn": "New Caledonia",
        "iso": "NC",
        "label": "+687 · Nova Caledônia",
        "searchText": "+687 nova caledônia new caledonia nc 687"
    },
    {
        "value": "+64",
        "country": "Nova Zelândia",
        "countryEn": "New Zealand",
        "iso": "NZ",
        "label": "+64 · Nova Zelândia",
        "searchText": "+64 nova zelândia new zealand nz 64"
    },
    {
        "value": "+968",
        "country": "Omã",
        "countryEn": "Oman",
        "iso": "OM",
        "label": "+968 · Omã",
        "searchText": "+968 omã oman om 968"
    },
    {
        "value": "+31",
        "country": "Países Baixos",
        "countryEn": "Netherlands",
        "iso": "NL",
        "label": "+31 · Países Baixos",
        "searchText": "+31 países baixos netherlands nl 31"
    },
    {
        "value": "+680",
        "country": "Palau",
        "countryEn": "Palau",
        "iso": "PW",
        "label": "+680 · Palau",
        "searchText": "+680 palau palau pw 680"
    },
    {
        "value": "+970",
        "country": "Palestina",
        "countryEn": "Palestine",
        "iso": "PS",
        "label": "+970 · Palestina",
        "searchText": "+970 palestina palestine ps 970"
    },
    {
        "value": "+507",
        "country": "Panamá",
        "countryEn": "Panama",
        "iso": "PA",
        "label": "+507 · Panamá",
        "searchText": "+507 panamá panama pa 507"
    },
    {
        "value": "+675",
        "country": "Papua-Nova Guiné",
        "countryEn": "Papua New Guinea",
        "iso": "PG",
        "label": "+675 · Papua-Nova Guiné",
        "searchText": "+675 papua-nova guiné papua new guinea pg 675"
    },
    {
        "value": "+92",
        "country": "Paquistão",
        "countryEn": "Pakistan",
        "iso": "PK",
        "label": "+92 · Paquistão",
        "searchText": "+92 paquistão pakistan pk 92"
    },
    {
        "value": "+595",
        "country": "Paraguai",
        "countryEn": "Paraguay",
        "iso": "PY",
        "label": "+595 · Paraguai",
        "searchText": "+595 paraguai paraguay py 595"
    },
    {
        "value": "+51",
        "country": "Peru",
        "countryEn": "Peru",
        "iso": "PE",
        "label": "+51 · Peru",
        "searchText": "+51 peru peru pe 51"
    },
    {
        "value": "+689",
        "country": "Polinésia Francesa",
        "countryEn": "French Polynesia",
        "iso": "PF",
        "label": "+689 · Polinésia Francesa",
        "searchText": "+689 polinésia francesa french polynesia pf 689"
    },
    {
        "value": "+48",
        "country": "Polônia",
        "countryEn": "Poland",
        "iso": "PL",
        "label": "+48 · Polônia",
        "searchText": "+48 polônia poland pl 48"
    },
    {
        "value": "+1",
        "country": "Porto Rico",
        "countryEn": "Puerto Rico",
        "iso": "PR",
        "label": "+1 · Porto Rico",
        "searchText": "+1 porto rico puerto rico pr 1"
    },
    {
        "value": "+351",
        "country": "Portugal",
        "countryEn": "Portugal",
        "iso": "PT",
        "label": "+351 · Portugal",
        "searchText": "+351 portugal portugal pt 351"
    },
    {
        "value": "+254",
        "country": "Quênia",
        "countryEn": "Kenya",
        "iso": "KE",
        "label": "+254 · Quênia",
        "searchText": "+254 quênia kenya ke 254"
    },
    {
        "value": "+996",
        "country": "Quirguistão",
        "countryEn": "Kyrgyzstan",
        "iso": "KG",
        "label": "+996 · Quirguistão",
        "searchText": "+996 quirguistão kyrgyzstan kg 996"
    },
    {
        "value": "+44",
        "country": "Reino Unido",
        "countryEn": "United Kingdom",
        "iso": "GB",
        "label": "+44 · Reino Unido",
        "searchText": "+44 reino unido united kingdom gb 44"
    },
    {
        "value": "+236",
        "country": "República Centro-Africana",
        "countryEn": "Central African Republic",
        "iso": "CF",
        "label": "+236 · República Centro-Africana",
        "searchText": "+236 república centro-africana central african republic cf 236"
    },
    {
        "value": "+1",
        "country": "República Dominicana",
        "countryEn": "Dominican Republic",
        "iso": "DO",
        "label": "+1 · República Dominicana",
        "searchText": "+1 república dominicana dominican republic do 1"
    },
    {
        "value": "+262",
        "country": "Reunião",
        "countryEn": "Réunion",
        "iso": "RE",
        "label": "+262 · Reunião",
        "searchText": "+262 reunião réunion re 262"
    },
    {
        "value": "+40",
        "country": "Romênia",
        "countryEn": "Romania",
        "iso": "RO",
        "label": "+40 · Romênia",
        "searchText": "+40 romênia romania ro 40"
    },
    {
        "value": "+250",
        "country": "Ruanda",
        "countryEn": "Rwanda",
        "iso": "RW",
        "label": "+250 · Ruanda",
        "searchText": "+250 ruanda rwanda rw 250"
    },
    {
        "value": "+7",
        "country": "Rússia",
        "countryEn": "Russia",
        "iso": "RU",
        "label": "+7 · Rússia",
        "searchText": "+7 rússia russia ru 7"
    },
    {
        "value": "+212",
        "country": "Saara Ocidental",
        "countryEn": "Western Sahara",
        "iso": "EH",
        "label": "+212 · Saara Ocidental",
        "searchText": "+212 saara ocidental western sahara eh 212"
    },
    {
        "value": "+508",
        "country": "Saint Pierre e Miquelon",
        "countryEn": "Saint Pierre and Miquelon",
        "iso": "PM",
        "label": "+508 · Saint Pierre e Miquelon",
        "searchText": "+508 saint pierre e miquelon saint pierre and miquelon pm 508"
    },
    {
        "value": "+685",
        "country": "Samoa",
        "countryEn": "Samoa",
        "iso": "WS",
        "label": "+685 · Samoa",
        "searchText": "+685 samoa samoa ws 685"
    },
    {
        "value": "+1",
        "country": "Samoa Americana",
        "countryEn": "American Samoa",
        "iso": "AS",
        "label": "+1 · Samoa Americana",
        "searchText": "+1 samoa americana american samoa as 1"
    },
    {
        "value": "+378",
        "country": "San Marino",
        "countryEn": "San Marino",
        "iso": "SM",
        "label": "+378 · San Marino",
        "searchText": "+378 san marino san marino sm 378"
    },
    {
        "value": "+290",
        "country": "Santa Helena",
        "countryEn": "Saint Helena",
        "iso": "SH",
        "label": "+290 · Santa Helena",
        "searchText": "+290 santa helena saint helena sh 290"
    },
    {
        "value": "+1",
        "country": "Santa Lúcia",
        "countryEn": "Saint Lucia",
        "iso": "LC",
        "label": "+1 · Santa Lúcia",
        "searchText": "+1 santa lúcia saint lucia lc 1"
    },
    {
        "value": "+590",
        "country": "São Bartolomeu",
        "countryEn": "Saint Barthélemy",
        "iso": "BL",
        "label": "+590 · São Bartolomeu",
        "searchText": "+590 são bartolomeu saint barthélemy bl 590"
    },
    {
        "value": "+1",
        "country": "São Cristóvão e Névis",
        "countryEn": "Saint Kitts and Nevis",
        "iso": "KN",
        "label": "+1 · São Cristóvão e Névis",
        "searchText": "+1 são cristóvão e névis saint kitts and nevis kn 1"
    },
    {
        "value": "+590",
        "country": "São Martinho",
        "countryEn": "Saint Martin",
        "iso": "MF",
        "label": "+590 · São Martinho",
        "searchText": "+590 são martinho saint martin mf 590"
    },
    {
        "value": "+239",
        "country": "São Tomé e Príncipe",
        "countryEn": "São Tomé and Príncipe",
        "iso": "ST",
        "label": "+239 · São Tomé e Príncipe",
        "searchText": "+239 são tomé e príncipe são tomé and príncipe st 239"
    },
    {
        "value": "+1",
        "country": "São Vicente e Granadinas",
        "countryEn": "Saint Vincent and the Grenadines",
        "iso": "VC",
        "label": "+1 · São Vicente e Granadinas",
        "searchText": "+1 são vicente e granadinas saint vincent and the grenadines vc 1"
    },
    {
        "value": "+248",
        "country": "Seicheles",
        "countryEn": "Seychelles",
        "iso": "SC",
        "label": "+248 · Seicheles",
        "searchText": "+248 seicheles seychelles sc 248"
    },
    {
        "value": "+221",
        "country": "Senegal",
        "countryEn": "Senegal",
        "iso": "SN",
        "label": "+221 · Senegal",
        "searchText": "+221 senegal senegal sn 221"
    },
    {
        "value": "+232",
        "country": "Serra Leoa",
        "countryEn": "Sierra Leone",
        "iso": "SL",
        "label": "+232 · Serra Leoa",
        "searchText": "+232 serra leoa sierra leone sl 232"
    },
    {
        "value": "+381",
        "country": "Sérvia",
        "countryEn": "Serbia",
        "iso": "RS",
        "label": "+381 · Sérvia",
        "searchText": "+381 sérvia serbia rs 381"
    },
    {
        "value": "+65",
        "country": "Singapura",
        "countryEn": "Singapore",
        "iso": "SG",
        "label": "+65 · Singapura",
        "searchText": "+65 singapura singapore sg 65"
    },
    {
        "value": "+1",
        "country": "Sint Maarten",
        "countryEn": "Sint Maarten",
        "iso": "SX",
        "label": "+1 · Sint Maarten",
        "searchText": "+1 sint maarten sint maarten sx 1"
    },
    {
        "value": "+963",
        "country": "Síria",
        "countryEn": "Syria",
        "iso": "SY",
        "label": "+963 · Síria",
        "searchText": "+963 síria syria sy 963"
    },
    {
        "value": "+252",
        "country": "Somália",
        "countryEn": "Somalia",
        "iso": "SO",
        "label": "+252 · Somália",
        "searchText": "+252 somália somalia so 252"
    },
    {
        "value": "+94",
        "country": "Sri Lanka",
        "countryEn": "Sri Lanka",
        "iso": "LK",
        "label": "+94 · Sri Lanka",
        "searchText": "+94 sri lanka sri lanka lk 94"
    },
    {
        "value": "+249",
        "country": "Sudão",
        "countryEn": "Sudan",
        "iso": "SD",
        "label": "+249 · Sudão",
        "searchText": "+249 sudão sudan sd 249"
    },
    {
        "value": "+211",
        "country": "Sudão do Sul",
        "countryEn": "South Sudan",
        "iso": "SS",
        "label": "+211 · Sudão do Sul",
        "searchText": "+211 sudão do sul south sudan ss 211"
    },
    {
        "value": "+46",
        "country": "Suécia",
        "countryEn": "Sweden",
        "iso": "SE",
        "label": "+46 · Suécia",
        "searchText": "+46 suécia sweden se 46"
    },
    {
        "value": "+41",
        "country": "Suíça",
        "countryEn": "Switzerland",
        "iso": "CH",
        "label": "+41 · Suíça",
        "searchText": "+41 suíça switzerland ch 41"
    },
    {
        "value": "+597",
        "country": "Suriname",
        "countryEn": "Suriname",
        "iso": "SR",
        "label": "+597 · Suriname",
        "searchText": "+597 suriname suriname sr 597"
    },
    {
        "value": "+47",
        "country": "Svalbard e Jan Mayen",
        "countryEn": "Svalbard and Jan Mayen",
        "iso": "SJ",
        "label": "+47 · Svalbard e Jan Mayen",
        "searchText": "+47 svalbard e jan mayen svalbard and jan mayen sj 47"
    },
    {
        "value": "+66",
        "country": "Tailândia",
        "countryEn": "Thailand",
        "iso": "TH",
        "label": "+66 · Tailândia",
        "searchText": "+66 tailândia thailand th 66"
    },
    {
        "value": "+886",
        "country": "Taiwan",
        "countryEn": "Taiwan",
        "iso": "TW",
        "label": "+886 · Taiwan",
        "searchText": "+886 taiwan taiwan tw 886"
    },
    {
        "value": "+992",
        "country": "Tajiquistão",
        "countryEn": "Tajikistan",
        "iso": "TJ",
        "label": "+992 · Tajiquistão",
        "searchText": "+992 tajiquistão tajikistan tj 992"
    },
    {
        "value": "+255",
        "country": "Tanzânia",
        "countryEn": "Tanzania",
        "iso": "TZ",
        "label": "+255 · Tanzânia",
        "searchText": "+255 tanzânia tanzania tz 255"
    },
    {
        "value": "+420",
        "country": "Tchéquia",
        "countryEn": "Czechia",
        "iso": "CZ",
        "label": "+420 · Tchéquia",
        "searchText": "+420 tchéquia czechia cz 420"
    },
    {
        "value": "+670",
        "country": "Timor-Leste",
        "countryEn": "Timor-Leste",
        "iso": "TL",
        "label": "+670 · Timor-Leste",
        "searchText": "+670 timor-leste timor-leste tl 670"
    },
    {
        "value": "+228",
        "country": "Togo",
        "countryEn": "Togo",
        "iso": "TG",
        "label": "+228 · Togo",
        "searchText": "+228 togo togo tg 228"
    },
    {
        "value": "+690",
        "country": "Tokelau",
        "countryEn": "Tokelau",
        "iso": "TK",
        "label": "+690 · Tokelau",
        "searchText": "+690 tokelau tokelau tk 690"
    },
    {
        "value": "+676",
        "country": "Tonga",
        "countryEn": "Tonga",
        "iso": "TO",
        "label": "+676 · Tonga",
        "searchText": "+676 tonga tonga to 676"
    },
    {
        "value": "+1",
        "country": "Trinidad e Tobago",
        "countryEn": "Trinidad and Tobago",
        "iso": "TT",
        "label": "+1 · Trinidad e Tobago",
        "searchText": "+1 trinidad e tobago trinidad and tobago tt 1"
    },
    {
        "value": "+216",
        "country": "Tunísia",
        "countryEn": "Tunisia",
        "iso": "TN",
        "label": "+216 · Tunísia",
        "searchText": "+216 tunísia tunisia tn 216"
    },
    {
        "value": "+993",
        "country": "Turcomenistão",
        "countryEn": "Turkmenistan",
        "iso": "TM",
        "label": "+993 · Turcomenistão",
        "searchText": "+993 turcomenistão turkmenistan tm 993"
    },
    {
        "value": "+90",
        "country": "Turquia",
        "countryEn": "Turkey",
        "iso": "TR",
        "label": "+90 · Turquia",
        "searchText": "+90 turquia turkey tr 90"
    },
    {
        "value": "+688",
        "country": "Tuvalu",
        "countryEn": "Tuvalu",
        "iso": "TV",
        "label": "+688 · Tuvalu",
        "searchText": "+688 tuvalu tuvalu tv 688"
    },
    {
        "value": "+380",
        "country": "Ucrânia",
        "countryEn": "Ukraine",
        "iso": "UA",
        "label": "+380 · Ucrânia",
        "searchText": "+380 ucrânia ukraine ua 380"
    },
    {
        "value": "+256",
        "country": "Uganda",
        "countryEn": "Uganda",
        "iso": "UG",
        "label": "+256 · Uganda",
        "searchText": "+256 uganda uganda ug 256"
    },
    {
        "value": "+598",
        "country": "Uruguai",
        "countryEn": "Uruguay",
        "iso": "UY",
        "label": "+598 · Uruguai",
        "searchText": "+598 uruguai uruguay uy 598"
    },
    {
        "value": "+998",
        "country": "Uzbequistão",
        "countryEn": "Uzbekistan",
        "iso": "UZ",
        "label": "+998 · Uzbequistão",
        "searchText": "+998 uzbequistão uzbekistan uz 998"
    },
    {
        "value": "+678",
        "country": "Vanuatu",
        "countryEn": "Vanuatu",
        "iso": "VU",
        "label": "+678 · Vanuatu",
        "searchText": "+678 vanuatu vanuatu vu 678"
    },
    {
        "value": "+39",
        "country": "Vaticano",
        "countryEn": "Vatican City",
        "iso": "VA",
        "label": "+39 · Vaticano",
        "searchText": "+39 vaticano vatican city va 39"
    },
    {
        "value": "+58",
        "country": "Venezuela",
        "countryEn": "Venezuela",
        "iso": "VE",
        "label": "+58 · Venezuela",
        "searchText": "+58 venezuela venezuela ve 58"
    },
    {
        "value": "+84",
        "country": "Vietnã",
        "countryEn": "Vietnam",
        "iso": "VN",
        "label": "+84 · Vietnã",
        "searchText": "+84 vietnã vietnam vn 84"
    },
    {
        "value": "+681",
        "country": "Wallis e Futuna",
        "countryEn": "Wallis and Futuna",
        "iso": "WF",
        "label": "+681 · Wallis e Futuna",
        "searchText": "+681 wallis e futuna wallis and futuna wf 681"
    },
    {
        "value": "+260",
        "country": "Zâmbia",
        "countryEn": "Zambia",
        "iso": "ZM",
        "label": "+260 · Zâmbia",
        "searchText": "+260 zâmbia zambia zm 260"
    },
    {
        "value": "+263",
        "country": "Zimbábue",
        "countryEn": "Zimbabwe",
        "iso": "ZW",
        "label": "+263 · Zimbábue",
        "searchText": "+263 zimbábue zimbabwe zw 263"
    }
];
